import { useState, useEffect } from "react";
import "./CompletionPrompt.css";
import FormBuilder from "./FormBuilder";
import { taskSchemas } from "./task_schemas";
import { getDefaultValues } from "./form_utils";

export default function CompletionPrompt() {
  const [display, setDisplay] = useState(false);
  const [taskType, setTaskType] = useState("LINK_PICKING");
  const [values, setValues] = useState(() =>
    getDefaultValues(taskSchemas[taskType])
  );
  const [prompt, setPrompt] = useState("");
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  // reset values
  useEffect(() => {
    setValues(getDefaultValues(taskSchemas[taskType]));
  }, [taskType]);

  // regenerate JSON preview
  useEffect(() => {
    const schema = taskSchemas[taskType];
    const req = { task_type: taskType };
    for (const field of schema.fields) {
      const val = values[field.name];
      if (field.name === "created_at" && val) {
        req[field.name] = Math.floor(new Date(val).getTime() / 1000);
      } else {
        req[field.name] = val;
      }
    }
    setPrompt(JSON.stringify(req, null, 2));
  }, [taskType, values]);

  const handleFieldChange = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }));
  };

  async function sendV1Request() {
    try {
      const llm_v1_request = JSON.stringify(JSON.parse(prompt));
      let url = new URL("/completions-proxy", window.location.origin);
      const resp = await fetch(url, {
        method: "POST",
        body: llm_v1_request,
      });
      const data = await resp.json();
      setError(null);
      setResult(data);
    } catch (e) {
      setError(e.toString());
    }
  }

  return display ? (
    <div className="completion-prompt">
      <button onClick={() => setDisplay(false)}>← V1 Requests</button>

      <label>
        Task Type:
        <select
          value={taskType}
          onChange={(e) => setTaskType(e.target.value)}
        >
          {Object.keys(taskSchemas).map((tt) => (
            <option key={tt} value={tt}>
              {tt}
            </option>
          ))}
        </select>
      </label>

      <FormBuilder
        schema={taskSchemas[taskType]}
        values={values}
        onChange={handleFieldChange}
      />

      <label>
        JSON Payload (editable before sending):
        <textarea
          rows={8}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </label>

      {error && <p className="text-red">{error}</p>}
      {result && (
        <pre className="completion-prompt__result-box">
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
      <button onClick={sendV1Request}>Send V1 Request</button>
    </div>
  ) : (
    <button onClick={() => setDisplay(true)}>Send V1 Requests →</button>
  );
}
